var _defs, _style, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8351 2691",
    width: 8351,
    height: 2691,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shutterstock-1681169677-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-149.706,2105.442,0,5971.801,2239.628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e6e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-348.133,1624.979,0,5937.152,2586.514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e6e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-318.975,826.69,0,1668.808,2408.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e6e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-456.474,2428.007,0,3762.219,2548.228)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e6e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-319.286,471.034,0,2413.936,2411.251)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e6e9"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: url(#g2) } \n\t\t.s2 { fill: #fefefe } \n\t\t.s3 { fill: url(#g3) } \n\t\t.s4 { fill: url(#g4) } \n\t\t.s5 { fill: url(#g5) } \n\t\t.s6 { fill: #b5b5b5 } \n\t\t.s7 { fill: #9da8ae } \n\t\t.s8 { fill: #454546 } \n\t\t.s9 { fill: #6d7d85 } \n\t\t.s10 { fill: #98abb5 } \n\t\t.s11 { fill: #bdbfc1 } \n\t\t.s12 { fill: #231f20 } \n\t\t.s13 { fill: #c0cdd4 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Artboards_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "203214203C203204201[ 2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "203214203C203204201[ 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m7026.1 2125.8h0.7c-21.6-34.7-70.3-35.9-70.3-35.9h-1958.7c-52.7 0-71.8 37.5-71.8 37.5l0.3 0.1c-5.1 5.8 0.7 14.8 10.1 23.2l225.6 88.9h1627.9 0.8l227.2-88.9c10.3-9.2 16.3-19.1 8.2-24.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m6786.9 2238.4v102.1 246h-1624.9v-246-102.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m5224 2300.2v280.7h1500.9v-280.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m2143.7 2266.4v33.4c0 2.4-1.8 4.4-4.1 4.7v52.5c0 28.4-23.3 51.7-51.8 51.7h-719c-28.5 0-51.8-23.3-51.8-51.7v-215.4c0-28.5 23.3-51.8 51.8-51.8h719c28.5 0 51.8 23.3 51.8 51.8v68.3c2.3 0.3 4.1 2.3 4.1 4.7v33.4c0 2.4-1.8 4.3-4.1 4.7v9.1c2.3 0.3 4.1 2.3 4.1 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2079.3 2143.3h-707.7c-14.3 0-25.9 11.7-25.9 25.9v141.8 31.7c0 14.2 11.6 25.9 25.9 25.9h707.7c14.2 0 25.9-11.7 25.9-25.9v-104.9-68.6c0-14.2-11.7-25.9-25.9-25.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m5019.1 2548.2v-23.3c0-59.1-48.4-107.6-107.6-107.6h-856.8l16.4-101.1 25.7-158.2h66 114.5c0 0 65.9-3.6 88.5-66.2h-1121.4c22.6 62.6 88.5 66.2 88.5 66.2h114.6 66l25.7 158.2 16.4 101.1h-856.9c-59.1 0-107.6 48.5-107.6 107.6v23.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m2753 2270.4c2.5 0 4.7 2.1 4.7 4.7v33.3c0 2.6-2.2 4.7-4.7 4.7h-0.1v24.8c0 64.9-62.5 73.4-78.1 73.4h-305.8c-15.5 0-78-8.5-78-73.4v-24.8c-2.5-0.2-4.4-2.2-4.4-4.7v-43.6c0-2.4 1.9-4.5 4.4-4.6v-94.9c0-64.9 62.5-73.3 78-73.3h305.8c15.6 0 78.1 8.4 78.1 73.3v53.5h0.1c2.5 0 4.7 2.1 4.7 4.7v33.3c0 2.5-2.2 4.7-4.7 4.7h-0.1v8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2734.8 2165.2c0-8.8-7.2-16-16-16h-395.4c-8.8 0-16 7.2-16 16v176.2-3.4c0 8.8 7.2 16 16 16h395.4c8.8 0 16-7.2 16-16z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "203214203C203204201[ 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m3537.4 1869.2l-29.2 180.4h593.9l-29.3-180.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m4042.4 1682.1h-474.6l-30.4 187.1h535.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m4369.4 2095.1c-22.7-63.1-89.1-66.7-89.1-66.7h-115.3-719.8-115.3c0 0-66.3 3.6-89 66.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m4918.5 104.2h-2226.8c-59.6 0-108.3 48.7-108.3 108.3v46.2 1354.2 46.2c0 59.6 48.7 108.3 108.3 108.3h2226.8c59.6 0 108.4-48.7 108.4-108.3v-46.2-1354.2-46.2c0-59.6-48.8-108.3-108.4-108.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m3826.9 149.9c0 12-9.8 21.8-21.8 21.8-12 0-21.8-9.8-21.8-21.8 0-12 9.8-21.8 21.8-21.8 12 0 21.8 9.8 21.8 21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2676.7 200.8v1472h2256.9v-1472z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m2142.7 1075.2v-33.5c0-2.4-1.8-4.4-4.1-4.7v-52.8c0-28.6-23.4-52-52-52h-723c-28.7 0-52.1 23.4-52.1 52v1053.8c0 28.7 23.4 52.1 52.1 52.1h723c28.6 0 52-23.4 52-52.1v-905.9c2.3-0.3 4.1-2.3 4.1-4.7v-33.6c0-2.4-1.8-4.4-4.1-4.7v-9.2c2.3-0.3 4.1-2.3 4.1-4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1736.2 953.3c0 6.1-5 11.1-11.1 11.1-6.2 0-11.1-5-11.1-11.1 0-6.1 4.9-11.1 11.1-11.1 6.1 0 11.1 5 11.1 11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2078 972.5h-711.6c-14.3 0-26 11.8-26 26.1v736.3 275.3c0 14.3 11.7 26 26 26h711.6c14.3 0 26-11.7 26-26v-773.4-238.2c0-14.3-11.7-26.1-26-26.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m6142.7 2011.2h-327.5l-893.5 43.1c0 0 19.3 35.8 72.3 35.8h1971.2c0 0 49-1.1 70.7-34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m6084.6 2062c0 5-8.4 9.1-18.8 9.1h-168.1c-10.3 0-18.8-4.1-18.8-9.1v-0.7c0-5 8.5-9.1 18.8-9.1h168.1c10.4 0 18.8 4.1 18.8 9.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m5159.3 1845.6l-227.1 186.5c-15.9 13.5-21.7 28.5 18.3 28.5h12.7l1834.4-215z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m7026.9 2032.1l-228.5-186.5h-0.8l-1834.4 215h891.9v-2.6c0-12.4 10.2-22.7 22.7-22.7h203.6c12.4 0 22.7 10.3 22.7 22.7v2.6h363.6 541c39.9 0 34.1-15 18.2-28.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m5159.3 1845.6v-939.4c0-39.9 32.7-72.6 72.6-72.6h1493.8c40 0 72.7 32.7 72.7 72.6v939.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m6735.8 1798.7h-1514v-900.4h1514z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m5993.4 864.3c0 8-6.5 14.6-14.6 14.6-8.1 0-14.6-6.6-14.6-14.6 0-8.1 6.5-14.6 14.6-14.6 8.1 0 14.6 6.5 14.6 14.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5321.2 1869.3c-1.4 1.2-7.7 2.2-13.9 2.2h-91c-6.2 0-9.9-1-8.2-2.2l9-6.5c1.6-1.1 7.9-2.1 14-2.1h89.2c6.1 0 10 1 8.6 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5455.9 1869.3c-1.1 1.2-7.1 2.2-13.3 2.2h-91c-6.2 0-10.2-1-8.8-2.2l7.5-6.5c1.3-1.1 7.4-2.1 13.4-2.1h89.3c6.1 0 10.2 1 9.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5590.7 1869.3c-0.9 1.2-6.6 2.2-12.8 2.2h-91c-6.2 0-10.4-1-9.3-2.2l5.8-6.5c1.1-1.1 6.9-2.1 13-2.1h89.3c6.1 0 10.4 1 9.5 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5725.4 1869.3c-0.5 1.2-6.1 2.2-12.3 2.2h-91c-6.2 0-10.6-1-9.8-2.2l4.3-6.5c0.8-1.1 6.4-2.1 12.5-2.1h89.2c6.1 0 10.7 1 10.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5860.2 1869.3c-0.3 1.2-5.6 2.2-11.8 2.2h-91c-6.2 0-10.9-1-10.4-2.2l2.8-6.5c0.5-1.1 5.9-2.1 11.9-2.1h89.3c6.1 0 10.9 1 10.6 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5994.9 1869.3c0 1.2-5 2.2-11.2 2.2h-91c-6.2 0-11.1-1-10.9-2.2l1.2-6.5c0.2-1.1 5.3-2.1 11.4-2.1h89.3c6.1 0 11 1 11.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6129.7 1869.3c0.3 1.2-4.5 2.2-10.7 2.2h-91.1c-6.2 0-11.3-1-11.4-2.2l-0.4-6.5c0-1.1 4.9-2.1 11-2.1h89.2c6.1 0 11.3 1 11.6 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6264.4 1869.3c0.6 1.2-4 2.2-10.2 2.2h-91c-6.2 0-11.6-1-11.9-2.2l-2-6.5c-0.3-1.1 4.4-2.1 10.4-2.1h89.3c6.1 0 11.5 1 12.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6399.1 1869.3c0.9 1.2-3.4 2.2-9.6 2.2h-91c-6.2 0-11.8-1-12.5-2.2l-3.5-6.5c-0.6-1.1 3.8-2.1 9.9-2.1h89.3c6.1 0 11.7 1 12.6 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6533.9 1869.3c1.2 1.2-2.9 2.2-9.1 2.2h-91.1c-6.2 0-12-1-12.9-2.2l-5.1-6.5c-0.9-1.1 3.3-2.1 9.4-2.1h89.3c6 0 11.9 1 13.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6758.4 1869.3c1.7 1.2-2 2.2-8.2 2.2h-181.2c-6.2 0-12.3-1-13.5-2.2l-6.6-6.5c-1.2-1.1 2.8-2.1 8.8-2.1h177.7c6.1 0 12.4 1 14 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6656.3 1878.6c-1.4-1.2 2.5-2.2 8.8-2.2h91.8c6.2 0 12.7 1 14.4 2.2l9.6 6.9c1.8 1.2-2 2.3-8.4 2.3h-93.7c-6.3 0-12.8-1.1-14.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6519.4 1878.6c-1.2-1.2 3-2.2 9.2-2.2h91.8c6.3 0 12.5 1 14 2.2l7.9 6.9c1.4 1.2-2.6 2.3-9 2.3h-93.7c-6.4 0-12.6-1.1-13.7-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6382.4 1878.6c-0.9-1.2 3.5-2.2 9.8-2.2h91.8c6.2 0 12.2 1 13.4 2.2l6.2 6.9c1.1 1.2-3.1 2.3-9.5 2.3h-93.7c-6.4 0-12.3-1.1-13.2-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6245.4 1878.6c-0.6-1.2 4-2.2 10.3-2.2h91.8c6.3 0 12.1 1 12.9 2.2l4.5 6.9c0.9 1.2-3.6 2.3-10 2.3h-93.7c-6.4 0-12.1-1.1-12.7-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6108.4 1878.6c-0.3-1.2 4.6-2.2 10.8-2.2h91.9c6.2 0 11.8 1 12.3 2.2l2.9 6.9c0.5 1.2-4.3 2.3-10.6 2.3h-93.7c-6.4 0-11.8-1.1-12.1-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5971.4 1878.6c0-1.2 5.1-2.2 11.4-2.2h91.8c6.3 0 11.6 1 11.8 2.2l1.2 6.9c0.3 1.2-4.8 2.3-11.1 2.3h-93.7c-6.4 0-11.6-1.1-11.6-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5834.4 1878.6c0.3-1.2 5.7-2.2 11.9-2.2h91.9c6.2 0 11.3 1 11.2 2.2l-0.4 6.9c-0.1 1.2-5.4 2.3-11.8 2.3h-93.6c-6.4 0-11.4-1.1-11-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5697.4 1878.6c0.6-1.2 6.2-2.2 12.5-2.2h91.8c6.3 0 11.1 1 10.7 2.2l-2.1 6.9c-0.4 1.2-5.9 2.3-12.3 2.3h-93.6c-6.4 0-11.1-1.1-10.5-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5560.4 1878.6c0.9-1.2 6.8-2.2 13-2.2h91.8c6.3 0 10.9 1 10.2 2.2l-3.7 6.9c-0.7 1.2-6.5 2.3-12.9 2.3h-93.7c-6.3 0-10.8-1.1-9.8-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5423.4 1878.6c1.2-1.2 7.3-2.2 13.6-2.2h91.8c6.2 0 10.6 1 9.6 2.2l-5.4 6.9c-1 1.2-7 2.3-13.4 2.3h-93.7c-6.3 0-10.5-1.1-9.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5195.1 1878.6c1.7-1.2 8.2-2.2 14.5-2.2h182.7c6.3 0 10.4 1 9.1 2.2l-7 6.9c-1.3 1.2-7.6 2.3-14 2.3h-186.4c-6.4 0-10.2-1.1-8.4-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6677.3 1896.2c-1.6-1.3 2.4-2.4 8.9-2.4h94.6c6.5 0 13.2 1.1 15 2.4l10.2 7.3c1.9 1.3-2 2.4-8.6 2.4h-96.6c-6.6 0-13.3-1.1-14.9-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6536 1896.2c-1.2-1.3 3-2.4 9.5-2.4h94.7c6.4 0 12.9 1.1 14.4 2.4l8.4 7.3c1.5 1.3-2.6 2.4-9.2 2.4h-96.6c-6.6 0-13-1.1-14.3-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6394.8 1896.2c-1-1.3 3.6-2.4 10-2.4h94.7c6.4 0 12.7 1.1 13.8 2.4l6.7 7.3c1.2 1.3-3.2 2.4-9.8 2.4h-96.6c-6.6 0-12.7-1.1-13.7-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6253.5 1896.2c-0.6-1.3 4.2-2.4 10.6-2.4h94.7c6.4 0 12.4 1.1 13.3 2.4l4.9 7.3c0.8 1.3-3.8 2.4-10.4 2.4h-96.6c-6.6 0-12.5-1.1-13.1-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6112.3 1896.2c-0.3-1.3 4.7-2.4 11.2-2.4h94.6c6.5 0 12.2 1.1 12.7 2.4l3.1 7.3c0.6 1.3-4.3 2.4-10.9 2.4h-96.6c-6.6 0-12.2-1.1-12.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5971 1896.2c0-1.3 5.3-2.4 11.8-2.4h94.6c6.5 0 11.9 1.1 12.2 2.4l1.3 7.3c0.3 1.3-4.9 2.4-11.5 2.4h-96.6c-6.6 0-12-1.1-11.9-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5829.8 1896.2c0.3-1.3 5.9-2.4 12.3-2.4h94.7c6.4 0 11.6 1.1 11.5 2.4l-0.4 7.3c-0.1 1.3-5.5 2.4-12.1 2.4h-96.6c-6.6 0-11.7-1.1-11.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5688.5 1896.2c0.7-1.3 6.5-2.4 12.9-2.4h94.7c6.4 0 11.4 1.1 11 2.4l-2.2 7.3c-0.4 1.3-6.1 2.4-12.7 2.4h-96.7c-6.5 0-11.4-1.1-10.7-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5547.3 1896.2c0.9-1.3 7-2.4 13.4-2.4h94.7c6.4 0 11.1 1.1 10.4 2.4l-3.9 7.3c-0.8 1.3-6.7 2.4-13.3 2.4h-96.7c-6.5 0-11.1-1.1-10.1-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5406 1896.2c1.3-1.3 7.6-2.4 14.1-2.4h94.6c6.5 0 10.9 1.1 9.9 2.4l-5.8 7.3c-1 1.3-7.3 2.4-13.8 2.4h-96.7c-6.6 0-10.8-1.1-9.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5170.6 1896.2c1.8-1.3 8.6-2.4 15-2.4h188.4c6.5 0 10.7 1.1 9.3 2.4l-7.5 7.3c-1.4 1.3-7.9 2.4-14.4 2.4h-192.4c-6.5 0-10.4-1.1-8.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6700.2 1915.5c-1.7-1.4 2.4-2.5 9.1-2.5h97.8c6.6 0 13.6 1.1 15.6 2.5l10.8 7.8c2 1.4-1.9 2.6-8.7 2.6h-99.9c-6.8 0-13.8-1.2-15.5-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6554.3 1915.5c-1.4-1.4 3-2.5 9.7-2.5h97.8c6.6 0 13.4 1.1 15 2.5l8.9 7.8c1.7 1.4-2.5 2.6-9.3 2.6h-99.9c-6.8 0-13.5-1.2-14.9-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6408.3 1915.5c-0.9-1.4 3.7-2.5 10.4-2.5h97.7c6.7 0 13.2 1.1 14.4 2.5l7.1 7.8c1.3 1.4-3.2 2.6-10 2.6h-99.9c-6.8 0-13.1-1.2-14.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6262.4 1915.5c-0.6-1.4 4.3-2.5 11-2.5h97.7c6.7 0 12.9 1.1 13.8 2.5l5.2 7.8c1 1.4-3.8 2.6-10.6 2.6h-99.9c-6.8 0-12.9-1.2-13.6-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m6116.5 1915.5c-0.3-1.4 4.9-2.5 11.6-2.5h97.7c6.7 0 12.6 1.1 13.2 2.5l3.3 7.8c0.6 1.4-4.4 2.6-11.2 2.6h-99.9c-6.8 0-12.6-1.2-13-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5532.9 1915.5c1-1.4 7.3-2.5 13.9-2.5h97.8c6.7 0 11.5 1.1 10.8 2.5l-4.3 7.8c-0.8 1.4-7 2.6-13.8 2.6h-99.8c-6.8 0-11.5-1.2-10.5-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5386.9 1915.5c1.4-1.4 8-2.5 14.6-2.5h97.8c6.7 0 11.2 1.1 10.1 2.5l-6.1 7.8c-1.1 1.4-7.6 2.6-14.4 2.6h-99.9c-6.8 0-11.2-1.2-9.8-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5264.9 1915.5c1.7-1.4 7.5-2.5 12.9-2.5h80c5.4 0 8.7 1.1 7.3 2.5l-8 7.8c-1.5 1.4-7.2 2.6-12.8 2.6h-81.7c-5.5 0-8.7-1.2-7-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5145.6 1915.5c1.9-1.4 7.9-2.5 13.4-2.5h79.9c5.5 0 8.6 1.1 6.9 2.5l-9.6 7.8c-1.7 1.4-7.7 2.6-13.3 2.6h-81.7c-5.5 0-8.4-1.2-6.5-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m5678.4 1915.5c0.7-1.4 6.7-2.5 13.4-2.5h390.6c6.7 0 12.3 1.1 12.6 2.5l1.4 7.8c0.3 1.4-5 2.6-11.8 2.6h-399.1c-6.8 0-11.8-1.2-11-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m6355.1 2012.3c3 5.5 0.4 9.9-5.8 9.9h-741.3c-6.2 0-8.8-4.4-5.6-9.8l39-66.9c3.2-5.4 10.9-9.8 17.1-9.8h642.5c6.3 0 13.9 4.4 16.9 9.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m2748.1 1368.3c2.6 0 4.7-2.1 4.7-4.8v-33.5c0-2.7-2.1-4.8-4.7-4.8h-0.1v-25.1c0-65.5-63.1-74-78.8-74h-308.8c-15.7 0-78.9 8.5-78.9 74v25.1c-2.4 0.2-4.3 2.3-4.3 4.8v43.9c0 2.5 1.9 4.6 4.3 4.8v637.3c0 65.6 63.2 74.1 78.9 74.1h308.8c15.7 0 78.8-8.5 78.8-74.1v-595.6h0.1c2.6 0 4.7-2.1 4.7-4.7v-33.6c0-2.6-2.1-4.8-4.7-4.8h-0.1v-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m2713.6 1283.9h-399.3c-8.9 0-16.1 7.3-16.1 16.2v482.7 233.3c0 8.9 7.2 16.2 16.1 16.2h399.3c8.9 0 16.2-7.3 16.2-16.2v-514.8-201.2c0-8.9-7.3-16.2-16.2-16.2z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "203214203C203204201[ 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineShop);
export default __webpack_public_path__ + "static/media/online-shop.a8dd0aa751fec91da64dbc0b001c077a.svg";
export { ForwardRef as ReactComponent };